import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const MB_SVG_ChevronLeft = React.memo((props: {
    /**
     * The size of the component.
     */
    size?: number,

    /**
     * The color of the component.
     */
    color?: string,

    /**
     * The width of the stroke.
     */
    strokeWidth?: number,

    /**
     * The style of the component's container.
     */
    containerStyle?: StyleProp<ViewStyle>
}) => {
    return (
        <View style={props.containerStyle}>
            <Svg
                width={props.size ?? 12}
                height={props.size ? (props.size * (8 / 12)) : 8}
                viewBox="0 0 12 8"
                fill="none"
                style={{ transform: [{ rotateZ: '90deg' }] }}
            >
                <Path
                    d="M1.136 1.538L6.068 6.46 11 1.538"
                    stroke={props.color ?? 'white'}
                    strokeWidth={props.strokeWidth ?? 1.4}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </Svg>
        </View>
    );
});

export { MB_SVG_ChevronLeft };
